"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var RenderIf_1 = __importDefault(require("../../RenderIf"));
var VideoPlayerIds_1 = __importDefault(require("../../../VideoPlayerIds"));
var VideoButtonPlaybackRate_1 = __importDefault(require("../styles/VideoButtonPlaybackRate"));
var ButtonPlaybackRate1_1 = __importDefault(require("../assets/ButtonPlaybackRate1"));
var ButtonPlaybackRate12_1 = __importDefault(require("../assets/ButtonPlaybackRate12"));
var ButtonPlaybackRate15_1 = __importDefault(require("../assets/ButtonPlaybackRate15"));
var ButtonPlaybackRate17_1 = __importDefault(require("../assets/ButtonPlaybackRate17"));
var ButtonPlaybackRate2_1 = __importDefault(require("../assets/ButtonPlaybackRate2"));
var VideoButtonPlaybackRate = function (_a) {
    var controller = _a.controller;
    var _b = react_1.useState(1), playbackRateValue = _b[0], setPlaybackRateValue = _b[1];
    var handlePlaybackRate = function () {
        var nextPlaybackRateValue = controller === null || controller === void 0 ? void 0 : controller.getPlaybackRateValue();
        var video = controller === null || controller === void 0 ? void 0 : controller.video;
        video.playbackRate = nextPlaybackRateValue;
        setPlaybackRateValue(nextPlaybackRateValue);
    };
    react_1.useEffect(function () {
        var video = controller === null || controller === void 0 ? void 0 : controller.video;
        if (video) {
            video.playbackRate = playbackRateValue;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controller === null || controller === void 0 ? void 0 : controller.video.src, controller]);
    return (jsx_runtime_1.jsxs(VideoButtonPlaybackRate_1.default, __assign({ id: VideoPlayerIds_1.default.ButtonPlaybackRate, onClick: handlePlaybackRate }, { children: [jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: playbackRateValue === 1 }, { children: jsx_runtime_1.jsx(ButtonPlaybackRate1_1.default, {}, void 0) }), void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: playbackRateValue === 1.2 }, { children: jsx_runtime_1.jsx(ButtonPlaybackRate12_1.default, {}, void 0) }), void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: playbackRateValue === 1.5 }, { children: jsx_runtime_1.jsx(ButtonPlaybackRate15_1.default, {}, void 0) }), void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: playbackRateValue === 1.7 }, { children: jsx_runtime_1.jsx(ButtonPlaybackRate17_1.default, {}, void 0) }), void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: playbackRateValue === 2 }, { children: jsx_runtime_1.jsx(ButtonPlaybackRate2_1.default, {}, void 0) }), void 0)] }), void 0));
};
exports.default = VideoButtonPlaybackRate;
